"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.baseFields = void 0;
var _core = require("@material-ui/core");
var _react = _interopRequireDefault(require("react"));
var _BaseForm = _interopRequireDefault(require("react-platform-components/dist/BaseComponents/BaseForm"));
var _BaseInjectors = require("react-platform-components/dist/BaseComponents/BaseInjectors");
var _formFields = require("react-platform-components/dist/form-fields");
var _formValidators = require("react-platform-components/dist/form-validators");
var _Translations = require("react-platform-components/dist/Translations");
var _config = require("../config");
var _moment = _interopRequireDefault(require("moment"));
var _helpers = require("react-platform-components/dist/helpers");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var AddressOfStoreFields;
try {
  AddressOfStoreFields = require('react-platform-address-of-store/dist/AddressOfStore/AddressOfStoreFields').default;
} catch (error) {}
var CategoryOfStoreField = null;
try {
  CategoryOfStoreField = require('react-platform-category-of-store/dist/CategoryOfStore/CategoryOfStoreField').default;
} catch (error) {
  console.log('module category of store not exist');
}
var setInitialAddressOfStoreValues = null;
try {
  setInitialAddressOfStoreValues = require('react-platform-address-of-store/dist/AddressOfStore/AddressOfStoreFields').setInitialAddressOfStoreValues;
} catch (error) {
  console.log('module address of store not exist');
}
var SpecificitiesOfStoreFields = null;
try {
  SpecificitiesOfStoreFields = require('react-platform-specificity-of-store/dist/SpecificityOfStoreWithSections/SpecificitiesOfStoreFields').SpecificitiesOfStoreFields;
} catch (error) {
  console.log('cannot find SpecificitiesOfStoreFields');
}
var baseFields = function baseFields(props) {
  var AddressOfStoreFieldsComponent = props.AddressOfStoreFieldsComponent || AddressOfStoreFields;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "xs:p-12 md:p-12 pt-80 flex flex-1 flex-col items-center justify-center md:flex-row md:items-end ".concat(props.classes.header),
    style: {
      backgroundImage: props.store.background_url ? "url(\"".concat((0, _helpers.joinPaths)(_config.BASE_URL, props.store.background_url), "\")") : props.store.background_url
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-1 flex-col items-center justify-center md:flex-row md:items-center md:justify-start white"
  }, /*#__PURE__*/_react.default.createElement(_formFields.ImageUploaderEditable, {
    name: "logo",
    image_name: "logo_image_data",
    style: {
      marginBottom: -83
    },
    onSelectImage: function onSelectImage(img) {
      return props.setFieldValue('logo_image_data', img);
    }
  })), _config.HIDE_BUTTON_COVER_UPLOADER && /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-1 flex-col items-center justify-center md:flex-row md:items-center md:justify-end white"
  }, /*#__PURE__*/_react.default.createElement(_formFields.ButtonImageUploader, {
    name: "background",
    onSelectImage: function onSelectImage(img) {
      return props.setFieldValue('background_image_data', img);
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex items-center justify-end"
  })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 2,
    alignItems: "center",
    className: props.classes.formFields
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    name: "name",
    label: "Titre",
    margin: "normal",
    variant: "outlined",
    fullWidth: true,
    required: true,
    validate: (0, _formValidators.validators)([(0, _formValidators.required)()])
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    name: "description",
    label: "Description",
    margin: "normal",
    variant: "outlined",
    multiline: true,
    rows: "4",
    fullWidth: true,
    required: true,
    validate: (0, _formValidators.validators)([(0, _formValidators.required)()])
  })), CategoryOfStoreField && !props.isStoreFetchingInProgress && /*#__PURE__*/_react.default.createElement(CategoryOfStoreField, props), SpecificitiesOfStoreFields && !props.isStoreFetchingInProgress && /*#__PURE__*/_react.default.createElement(SpecificitiesOfStoreFields, props), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, AddressOfStoreFieldsComponent && /*#__PURE__*/_react.default.createElement(AddressOfStoreFieldsComponent, props)))));
};

// Form fields
exports.baseFields = baseFields;
var getFormExtraFields = function getFormExtraFields(props) {
  return [/*#__PURE__*/_react.default.createElement("div", null, baseFields(props), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    className: "my-10",
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 8,
    md: 2
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    disabled: props.updateInProgress,
    onClick: props.submitForm,
    fullWidth: true,
    variant: "contained",
    color: "primary"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Save"
  })))))];
};

// Create EditStoreForm
var _default = (0, _BaseInjectors.injectToForm)(_BaseForm.default, {
  formExtraFields: function formExtraFields(props) {
    return getFormExtraFields(props);
  },
  handleInitialValues: function handleInitialValues(props) {
    var store = props.store;
    // Set initial values
    var initialValues = _objectSpread({
      name: store && store.name || '',
      description: store && store.description || '',
      background: store && store.background_url ? store.background.original : "url(\"".concat(_config.STATIC_PATH, "/assets/images/backgrounds/header-bg.png\")"),
      logo: store && store.logo_url || '',
      category: ''
    }, setInitialAddressOfStoreValues && setInitialAddressOfStoreValues(store));
    // If store has AddressOfStoreFields update initital values with values of the store
    if (CategoryOfStoreField && store.category) initialValues['category'] = store.category.id;
    if (props.getCustomInitialValues) {
      initialValues = props.getCustomInitialValues(initialValues, store);
    }
    return initialValues;
  }
});
exports.default = _default;